var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubstituir(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_2",
    "data-name": "Camada 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 192 192",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada 1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#114D88",
    d: "m143.66,44.34L101.66,2.34s-.03-.03-.05-.05c-.17-.17-.35-.33-.53-.48-.09-.08-.19-.14-.29-.22-.11-.08-.22-.17-.34-.25-.11-.07-.22-.14-.34-.21-.11-.07-.22-.14-.33-.2-.11-.06-.23-.11-.34-.17-.12-.06-.24-.12-.37-.17-.11-.04-.22-.08-.33-.12-.14-.05-.27-.1-.41-.14-.11-.03-.21-.05-.32-.08-.15-.04-.29-.08-.44-.11-.12-.02-.23-.04-.35-.05-.14-.02-.28-.05-.42-.06-.19-.02-.38-.02-.57-.03-.07,0-.14-.01-.21-.01-.08,0-.15,0-.23.01-.19,0-.37.01-.56.03-.15.01-.29.04-.43.06-.12.02-.23.03-.34.05-.15.03-.3.07-.45.11-.1.03-.21.05-.31.08-.14.04-.28.1-.43.15-.1.04-.21.07-.31.11-.13.05-.26.12-.39.18-.11.05-.22.1-.32.16-.12.07-.24.14-.36.22-.1.06-.21.12-.31.19-.13.09-.26.19-.39.29-.08.06-.16.12-.24.18-.21.17-.4.35-.59.54l-42,42c-3.12,3.12-3.12,8.19,0,11.31,3.12,3.12,8.19,3.12,11.31,0l28.34-28.34v92.69c0,4.42,3.58,8,8,8s8-3.58,8-8V27.31l28.34,28.34c1.56,1.56,3.61,2.34,5.66,2.34s4.09-.78,5.66-2.34c3.12-3.12,3.12-8.19,0-11.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#114D88",
    d: "m176,192H16c-8.82,0-16-7.18-16-16v-56c0-4.42,3.58-8,8-8s8,3.58,8,8v56h160v-56c0-4.42,3.58-8,8-8s8,3.58,8,8v56c0,8.82-7.18,16-16,16Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubstituir);
export default __webpack_public_path__ + "static/media/substituir.36de02364f8105a7a2daa3cfcee534d5.svg";
export { ForwardRef as ReactComponent };